import { useState, useEffect } from 'react';
import { announcements } from '@/mocks/homeData';

export default function AnnouncementBar() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % announcements.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const item = announcements[current];

  return (
    <div className="relative w-full bg-primary-500 text-background-50 overflow-hidden">
      <div className="relative flex items-center justify-center px-4 py-2.5 text-center">
        <div className="flex items-center gap-2 text-sm font-medium">
          {item.isNew && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold uppercase tracking-wide">
              New
            </span>
          )}
          <span className="text-sm">{item.text}</span>
          <a
            href={item.link}
            className="inline-flex items-center gap-1 text-sm font-semibold underline underline-offset-2 hover:text-accent-300 transition-colors whitespace-nowrap"
          >
            Learn more
            <i className="ri-arrow-right-line text-xs" />
          </a>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-1 pb-1">
        {announcements.map((_, idx) => (
          <button
            key={_?.id ?? idx}
            type="button"
            onClick={() => setCurrent(idx)}
            className={`h-1 rounded-full transition-all duration-300 ${
              idx === current ? 'w-6 bg-background-50/80' : 'w-1.5 bg-background-50/30'
            }`}
            aria-label={`Announcement ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
}